import { Button, ButtonGroups } from "@nocios/presentation-kit";
import { useEffect, useState } from "react";
import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";
import { useSelector } from "react-redux";
import store from "src/Reducers/store";

const PageId = 1;
const BackPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA = () => {
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);

  const baseImageBG = `${Config.BASE_URL}/images/BG/`;
  const baseIcons = `${Config.BASE_URL}/images/icons/`;
  const baseImages = `${Config.BASE_URL}/images/screen_${PageId}/`;
  const rightSideImage_0 = `${baseImages}animation_0.png`;
  const rightSideImage_1 = `${baseImages}animation_1.png`;
  const rightSideImage_2 = `${baseImages}animation_2.png`;
  const rightSideImage_3 = `${baseImages}animation_3.png`;
  const rightSideImage_4 = `${baseImages}animation_4.png`;
  const rightSideImage_5 = `${baseImages}animation_5.png`;

  const [step, setStep] = useState<number>(0);

  useEffect(() => {
    if (PageId === currentPage) setTimeout(() => setStep(1), 400);
    else setStep(0);

    return () => {
      setStep(0);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  useEffect(() => {
    if (step >= 1 && step < 7) setTimeout(() => setStep((prev) => prev + 1), 300);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  const buttons = [
    {
      label: "TRY OUR PRODUCT",
      type: "back",
      onClick: () => setCurrentPage(NextPageId),
      startIcon: {
        icon: `${baseIcons}product.png`,
        style: { width: "var(--width-28)", height: "auto", paddingRight: "var(--width-6)" },
      },
      style: {
        width: "var(--width-237)",
        borderColor: "transparent",
        color: "#000",
        borderRadius: "var(--width-4)",
        background: "var(--Linear, linear-gradient(90deg, #C4E6FF 0%, #E2C3FF 100%))",
        boxShadow: "0px 5.702px 61.296px 0px rgba(255, 255, 255, 0.30)",
      },
    },
    {
      label: "WATCH DEMO VIDEO",
      type: "next",
      onClick: () => setCurrentPage(BackPageId),
      style: {
        borderRadius: "var(--width-4)",
        width: "var(--width-237)",
      },
    },
  ];

  const rightSideComponentStyle: React.CSSProperties = {
    position: "absolute",
    right: 0,
    top: 0,
    transition: "opacity .6s ease-in-out",
    width: "var(--width-1920)",
    height: "var(--height-1080)",
  };

  return {
    bgImage: `${baseImageBG}BG_1.jpg`,
    styleBody: {
      marginTop: "var(--width-155)",
    },
    title: "REVOLUTIONIZING ENTERTAINMENT\nEXPERIENCES ON A GLOBAL SCALE",
    styleTitle: {
      color: "#FFF",
      fontFamily: "Tungsten",
      fontSize: "var(--width-64)",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "110%",
      textTransform: "uppercase",
    },
    description:
      "As the global demand for personalized, seamless, and\nimmersive entertainment grows, the <b>Infosys\nEntertainment Platform</b> enables service providers to stay\nahead. Leveraging cutting-edge AI and advanced\ntechnologies, the platform delivers exceptional user\nengagement while unlocking significant business\nopportunities.",
    styleDescription: {
      color: "#FFF",
      fontFamily: "Myriad Pro",
      fontSize: "var(--width-24)",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "140%",
      marginTop: "var(--width-18)",
    },
    leftAfterDescription: (
      <ButtonGroups style={{ flexDirection: "column", gap: "var(--width-16)", marginTop: "var(--width-72)" }}>
        {buttons.map((button, index) => (
          <Button key={index} {...button} />
        ))}
      </ButtonGroups>
    ),
    rightSideComponent: (
      <>
        <img src={rightSideImage_0} alt="" style={{ ...rightSideComponentStyle, opacity: step > 1 ? 1 : 0 }} />
        <img src={rightSideImage_1} alt="" style={{ ...rightSideComponentStyle, opacity: step > 2 ? 1 : 0 }} />
        <img src={rightSideImage_2} alt="" style={{ ...rightSideComponentStyle, opacity: step > 3 ? 1 : 0 }} />
        <img src={rightSideImage_3} alt="" style={{ ...rightSideComponentStyle, opacity: step > 4 ? 1 : 0 }} />
        <img src={rightSideImage_4} alt="" style={{ ...rightSideComponentStyle, opacity: step > 5 ? 1 : 0 }} />
        <img src={rightSideImage_5} alt="" style={{ ...rightSideComponentStyle, opacity: step > 6 ? 1 : 0 }} />
      </>
    ),
  };
};

export default DATA;
